export const STATUS = ['待数据初始化','','人工整理数据','待计算','计算中','待检查','检查完成','发放完成'];
export const SHARE_TYPE = ['', '手续费分红', '交易排名奖励', '盈利排名奖励'];